import { SeasonTypeEnum } from '@coin/shared/core/util-enums';

export function encodeSeasonType(seasonType: SeasonTypeEnum) {
  switch (seasonType) {
    case SeasonTypeEnum.IncentiveV2:
      return 'incentive';
    case SeasonTypeEnum.SOG:
      return 'sog';
    case SeasonTypeEnum.GBR:
      return 'gbr';
    case SeasonTypeEnum.SpecialPayment:
    case SeasonTypeEnum.SpecialPaymentCash:
    case SeasonTypeEnum.SpecialPaymentEquity:
      return 'special-payment';
    case SeasonTypeEnum.PositionEvaluation:
      return 'position-evaluation';
    case SeasonTypeEnum.Restructuring:
      return 'restructuring';
    case SeasonTypeEnum.Merit:
      return 'merit';
    case SeasonTypeEnum.ExceptionalRecognitions:
      return 'exceptional-recognition';
    case SeasonTypeEnum.Unknown:
    default:
      throw new Error(`Unknown SeasonType: ${seasonType}`);
  }
}
